// React
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
// Actions
import orderActions from '../../redux/actions/orders-actions';
// Components
import NewKanbanCard from './NewKanbanCard';

const mapStateToProps = (
  {
    partnerReducer: {
      profile: { stores },
    },
  },
  { intl: { formatMessage } },
) => {
  const title = formatMessage({ id: 'newKanbanCard.title' });
  const totalStores = stores.length;
  return {
    totalStores,
    title,
  };
};

export default injectIntl(connect(mapStateToProps)(NewKanbanCard));
